import Axios from 'axios'
import Servers from '../../server'

export default {
    state: {
        whoami: null,
        usersMe: null,
        role: null,
        authenticated: false,
    },
    getters: {
        getWhoAmi(state) {
            return state.whoami
        },
        getRole(state) {
            return state.role
        },
        getAuthenticated(state) {
            return state.authenticated
        },
        getUserInfo(state){
            return state.usersMe
        }
    },
    mutations: {
        setMe(state, header) {
            state.whoami = header
        },
        setRole(state, header) {
            localStorage.setItem("role", header);
            state.role = header.role
        },
        setAuth(state, header) {
            localStorage.setItem("access_token", header.access_token);
            state.authenticated = true;
        },
        cleanAuth(state) {
            localStorage.clear();
            state.whoami = null;
            state.role = null;
            state.usersMe=null;
            state.authenticated = false;
        },
        setUserInfo(state, header){
            state.usersMe = header
        }
    },
    actions: {
        async checkSession(context) {
            try {
            let response = await Axios.get(Servers.serverApi + "api/users/whoami", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            });
            context.commit("setMe", response.data)
            context.commit("setRole", response.data.role)
            return response
            } catch (e) {
                localStorage.clear();
                this.$route.push("/")
            }
        },
        async authenticate(context, credentials) {
            let params = new URLSearchParams();
            params.set("username", credentials.email);
            params.set("password", credentials.password);
            params.set("grant_type", "password");

            let response = await Axios.post(Servers.serverApi + "oauth/token", params.toString(), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization:
                        "Basic bXlmcmFjLW1vYmlsZTpLMXJpdDNrTXlGcjRjUGw0dGZvcm0=",
                    Accept: "application/json"
                }
            })
            context.commit("setAuth", response.data)
            return response;


        },
        async logOut(context) {
            context.commit("cleanAuth")
        },
        async checkMe(context) {
            let response = await Axios.get(Servers.serverApi + "api/users/me", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            });
        
            context.commit("setUserInfo", response.data)

        }
    }
}